// extracted by mini-css-extract-plugin
module.exports = {"container":"InputArea_container__3U_t_","read-only-span":"InputArea_read-only-span__1WS3S"};